/** Largura máxima do conteúdo do formulário de agente. */
export const AGENT_FORM_LAYOUT_MAX = 1080;

/** Largura confortável para campos simples (input, select). */
export const AGENT_FORM_FIELD_MAX = 480;

/** Largura para blocos com grid (skills, parametrização). */
export const AGENT_FORM_CONTENT_MAX = 960;
